import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBOi_Y7j4bPTwZ3EXSXItaDcVqRkJiul6U",
  authDomain: "teachmego-f1353.firebaseapp.com",
  projectId: "teachmego-f1353",
  storageBucket: "teachmego-f1353.firebasestorage.app",
  messagingSenderId: "505658806547",
  appId: "1:505658806547:web:223db4ba0723bd2eab8ae6"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const messaging = getMessaging(app);
const db = getFirestore(app);

// Request FCM token
const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BCaobLUzpo_RWFMYttxbAUox2PJqEFQkZ-kOfmpb83lI1GIp_45FGX9JS7wy738ZnL_NnAnSggRN9NJ_E66hflg"
    });
    if (currentToken) {
      console.log("FCM Token:", currentToken);
      return currentToken;
    } else {
      console.log("No registration token available. Request permission to generate one.");
    }
  } catch (err) {
    console.error("An error occurred while retrieving token. ", err);
  }
};

// Listen for foreground messages
const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Message received. ", payload);
      resolve(payload);
    });
  });

const getIdToken = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error("User not logged in");
  return await user.getIdToken();
};


export { auth, provider, app, messaging, db, getIdToken, requestForToken, onMessageListener };
